// src/services/alphaVantage/rateLimiter.ts
import { ApiTier, API_CONFIG } from './config';

class RateLimiter {
  private callCount: number = 0;
  private dailyCallCount: number = 0;
  private resetTime: number = Date.now() + 60000;
  private dailyResetTime: number = this.getDailyResetTime();
  private tier: ApiTier = ApiTier.FREE;
  private queue: Array<{ resolve: () => void }> = [];
  
  constructor(tier: ApiTier = ApiTier.FREE) {
    this.tier = tier;
  }
  
  setTier(tier: ApiTier): void {
    this.tier = tier;
  }
  
  private getDailyResetTime(): number {
    const now = new Date();
    const tomorrow = new Date(now);
    tomorrow.setDate(tomorrow.getDate() + 1);
    tomorrow.setHours(0, 0, 0, 0);
    return tomorrow.getTime();
  }
  
  async acquireToken(): Promise<void> {
    const config = API_CONFIG[this.tier];
    
    // Reset minute counter
    if (Date.now() > this.resetTime) {
      this.callCount = 0;
      this.resetTime = Date.now() + 60000;
      
      // Process queued requests
      this.processQueue(config.maxCallsPerMinute);
    }
    
    // Reset daily counter
    if (Date.now() > this.dailyResetTime) {
      this.dailyCallCount = 0;
      this.dailyResetTime = this.getDailyResetTime();
    }
    
    // Check if we've exceeded daily limit
    if (this.dailyCallCount >= config.maxCallsPerDay) {
      return new Promise<void>(resolve => {
        this.queue.push({ resolve });
      });
    }
    
    // If under limit, allow request
    if (this.callCount < config.maxCallsPerMinute) {
      this.callCount++;
      this.dailyCallCount++;
      return Promise.resolve();
    }
    
    // Otherwise queue request
    return new Promise<void>(resolve => {
      this.queue.push({ resolve });
    });
  }
  
  private processQueue(limit: number): void {
    while (this.queue.length > 0 && this.callCount < limit) {
      const next = this.queue.shift();
      if (next) {
        this.callCount++;
        this.dailyCallCount++;
        next.resolve();
      }
    }
  }
}

export const rateLimiter = new RateLimiter();
